import script from "./CargoFormListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CargoFormListView.vue?vue&type=script&setup=true&lang=js"

import "./CargoFormListView.vue?vue&type=style&index=0&id=c048907c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c048907c"]])

export default __exports__